import { AdressOutlined, CheckmarkFilled, EmailOutlined, PhoneOutlined } from '@icon';
import { getWorkspaceDetail } from '@services/external/provider.api';
import { Descriptions, Drawer, Typography } from '@ui';
import React from 'react';
import { useIntl } from 'react-intl';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import TStore from 'types/store';
import { StyledWrapper } from './DetailWorkspaceModal.styled';

type TProps = {
  id?: string;
  onRequestClose: () => void;
  visible: boolean;
};

const AddEditWorkspacesModal: React.FC<TProps> = ({ id, onRequestClose, visible }) => {
  const providerId = useSelector((state: TStore) => state.users.business[0].id);
  const { formatMessage } = useIntl();
  const theme = useTheme();

  const { isLoading, data } = useQuery(
    ['getWorkspace', id],
    async () => {
      const { data: axData } = await getWorkspaceDetail(providerId as string, id!);
      return axData.data;
    },
    { enabled: visible && !!id },
  );

  return (
    <Drawer visible={visible} onClose={onRequestClose} destroyOnClose title={data?.name}>
      <StyledWrapper>
        <div className="image-placeholder">
          <img src={data?.imageUrl ?? require('@assets/png/Default_Ambulancia_IMG.png')} />
        </div>

        <div className="section">
          <Typography
            display="captionLarge"
            style={{ color: theme.color.tint.secondary, marginBottom: theme.spacings.text.XS }}
            as="div"
          >
            Kontaktné údaje
          </Typography>
          <Descriptions
            layout="horizontal"
            items={[
              {
                left: <Descriptions.Icon Icon={AdressOutlined} />,
                right: `${data?.name}, ${data?.address}, ${data?.postCode} ${data?.city}`,
              },
              {
                left: <Descriptions.Icon Icon={EmailOutlined} />,
                right: data?.contactEmail,
              },
              {
                left: <Descriptions.Icon Icon={PhoneOutlined} />,
                right: data?.contactPhone,
              },
            ]}
          />
        </div>
        <div className="line" />

        <div className="section">
          <Typography
            display="captionLarge"
            variant="default"
            style={{ color: theme.color.tint.secondary, paddingBottom: theme.spacings.text.XS }}
            as="div"
          >
            Základné údaje
          </Typography>
          <Descriptions
            layout="vertical"
            items={[
              ...(data?.workers ?? []).map((worker) => ({
                left: formatMessage({ id: `business_staff_role_${worker.role.name}` }),
                right: `${worker.titleBeforeName ?? ''} ${worker.firstName} ${worker.lastName} ${
                  worker.titleAfterName ?? ''
                }`,
              })),
              {
                left: formatMessage({ id: 'departments_detail_modal_insurance_companies' }),
                right: data?.insurancies
                  ? data.insurancies?.map((mi: any) => mi.name).join(', ')
                  : '-',
              },
            ]}
          />
        </div>
        <div className="line" />
        <div className="section">
          <Typography
            display="captionLarge"
            variant="default"
            style={{ color: theme.color.tint.secondary, paddingBottom: theme.spacings.text.XS }}
            as="div"
          >
            {formatMessage({ id: 'departments_modal_services' })}
          </Typography>
          <Descriptions
            items={(data?.workspaceTags ?? []).map((t) => ({
              left: <Descriptions.Icon Icon={CheckmarkFilled} color={theme.color.solid.success} />,
              right: t.name,
            }))}
            layout="horizontal"
          />
        </div>
        <div className="line" />
        <div className="section">
          <Typography
            display="captionLarge"
            variant="default"
            style={{ color: theme.color.tint.secondary, paddingBottom: theme.spacings.text.XS }}
            as="div"
          >
            Iné služby
          </Typography>
          {data?.info ? <Typography as="div">{data?.info}</Typography> : '-'}
        </div>
      </StyledWrapper>
    </Drawer>
  );
};

export default AddEditWorkspacesModal;
